import React from 'react';

import { connect } from 'react-redux';

import { withStyles, Snackbar, IconButton } from '@material-ui/core';
import { Clear, AddCircle } from '@material-ui/icons';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import PictureUpload from 'components/CustomUpload/PictureUpload';
import Api from '../../api/Api.js';
import ImageEndpoints from '../../api/ImageEndpoints';
import defaultUserImage from 'assets/img/no_profile.png';
import { store } from '../../redux/store';
import { SET_PROFILE_IMAGE, SET_PAGE_TITLE, UPDATE_USER_DETAILS } from '../../redux/types';

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import StatsWrapper from "components/Stats/StatsWrapper.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import AccountManagerGPChart from './ProfileStats/AccountManagerGPChart';
import AccountManagerGPTable from './ProfileStats/AccountManagerGPTable';

import {
    cardTitle,
    roseColor
} from "assets/jss/material-dashboard-pro-react.jsx";
import SmallModal from '../../components/Modal/SmallModal';
import AuthEndpoints from '../../api/AuthEndpoints';
import MFADialog from './Dialogs/MFADialog';
import Loading from '../../components/Loading/Loading';
import UserEndpoints from '../../api/UserEndpoints';
import SMSDialog from './Dialogs/SMSDialog';
import EmailDialog from './Dialogs/EmailDialog';
import NotificationModal from '../../components/Modal/NotificationModal';

const styles = {
    cardTitle,
    cardTitleWhite: {
        ...cardTitle,
        color: "#FFFFFF",
        marginTop: "0"
    },
    cardCategoryWhite: {
        margin: "0",
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: ".875rem"
    },
    cardCategory: {
        color: "#999999",
        marginTop: "10px"
    },
    icon: {
        color: "#333333",
        margin: "10px auto 0",
        width: "130px",
        height: "130px",
        border: "1px solid #E5E5E5",
        borderRadius: "50%",
        lineHeight: "174px",
        "& svg": {
            width: "55px",
            height: "55px"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            width: "55px",
            fontSize: "55px"
        }
    },
    iconRose: {
        color: roseColor
    },
    marginTop30: {
        marginTop: "30px"
    },
    testimonialIcon: {
        marginTop: "30px",
        "& svg": {
            width: "40px",
            height: "40px"
        }
    },
    cardTestimonialDescription: {
        fontStyle: "italic",
        color: "#999999"
    }
};

class ViewProfile extends React.Component {

    constructor(props) {
        super(props);

        console.log(props.allUsers);

        var user = null;

        if (props.match.url === "/profile") {
            user = props.user;
            this.isOwnProfile = true;
        } else {
            var { user_id } = props.match.params;
            user = props.allUsers.find(x => x.id == user_id);
            store.dispatch({ type: SET_PAGE_TITLE, payload: user.name + (user.surname ? " " + user.surname : "") })
        }

        this.state = {
            snackbarOpen: false,
            snackbarColor: 'danger',
            snackbarMessage: 'Not Message',
            snackbarPlace: 'tc',
            mfaDialog: false,
            smsDialog: false,
            dialog: false,
            dialogText: '',
            user,
            loading: !Boolean(user),
            addOTPDialog: false
        }

        this.refreshCurrentUser();
    }

    areYouSureFunction = () => { };

    changeProfilePicture = (file) => {
        Api.fileUpload(ImageEndpoints.upload, [file], { bind: "user", bind_id: this.state.user.id })
            .then(({ data }) => {
                store.dispatch({ type: SET_PROFILE_IMAGE, payload: data.image })
            })
    }

    timeout;
    snackbar = (dismiss, message = '', color = 'danger', place = this.state.snackbarPlace) => {
        clearTimeout(this.timeout);
        this.setState(
            { snackbarOpen: !dismiss, snackbarColor: color, snackbarMessage: message, snackbarPlace: place },
            () => this.timeout = setTimeout(() => this.setState({ snackbarOpen: false }), 10000)
        );
    };

    user = {};
    isOwnProfile = false;

    refreshCurrentUser() {
        var current_user_id = 0;

        if (this.props.match.url === "/profile") {
            current_user_id = this.props.user.id;
        } else {
            var { user_id } = this.props.match.params;
            current_user_id = user_id;
        }

        Api.get(UserEndpoints.byId, { id: current_user_id })
            .then(({ data }) => {
                store.dispatch({ type: UPDATE_USER_DETAILS, payload: data });
                this.setState({ user: data, loading: false });
            })
    }

    removeEmailOtp() {
        this.areYouSureFunction = () => {
            Api.get(AuthEndpoints.removeEmailAuth)
                .then(() => {
                    this.refreshCurrentUser();
                })
                .catch((e) => {
                    console.error(e)
                })
        }

        this.setState({ dialogText: "Are you sure you want to remove Email Authentication?", dialog: true });
    }

    removeSMSOtp() {
        this.areYouSureFunction = () => {
            Api.get(AuthEndpoints.removeSMSAuth)
                .then(() => {
                    this.refreshCurrentUser();
                })
                .catch((e) => {
                    console.error(e)
                })
        }

        this.setState({ dialogText: "Are you sure you want to remove SMS Authentication?", dialog: true });
    }

    removeMFAOtp() {
        this.areYouSureFunction = () => {
            Api.get(AuthEndpoints.removeMFA)
                .then(() => {
                    this.refreshCurrentUser();
                })
                .catch((e) => {
                    console.error(e)
                })
        }

        this.setState({ dialogText: "Are you sure you want to remove Two Factor Authentication?", dialog: true });
    }

    addEmailOtp = () => this.setState({ emailDialog: true })

    addSMSOtp = () => this.setState({ smsDialog: true })

    addMFAOtp = () => this.setState({ mfaDialog: true })

    render() {

        const { classes } = this.props;

        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <Card profile>
                        <CardAvatar profile>
                            <PictureUpload
                                preview={this.state.user.image ? `/api/image/get?id=${this.state.user.image}` : defaultUserImage}
                                onImagePicked={(file) => this.changeProfilePicture(file)}
                            />
                        </CardAvatar>
                        <CardBody profile>
                            <h3 className={classes.cardCategory} style={{ paddingBottom: 18 }}>{this.state.user.name} {this.state.user.surname || ""}</h3>
                            <h4 className={classes.cardTitle} style={{ paddingBottom: 12 }}>{this.state.user.description}</h4>

                            <hr />

                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 10, paddingRight: 10, justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ textAlign: 'left', fontWeight: 'bold', paddingTop: 10, paddingBottom: 10 }}>SMS Authentication:</div> {/* TODO: Implement SMS OTP */}
                                    {
                                        this.state.user.otp_sms_enabled ?
                                            <div style={{ textAlign: 'right', color: 'var(--green)', flex: 1 }}>{this.state.user.contact_number} </div>
                                            :
                                            <div style={{ textAlign: 'right', color: 'var(--red)', flex: 1 }}>Disabled</div>
                                    }
                                    {
                                        this.isOwnProfile ?
                                            <div style={{ paddingLeft: 10 }}>
                                                {
                                                    this.state.user.otp_sms_enabled ?
                                                        <IconButton color="secondary" onClick={() => this.removeSMSOtp()}><Clear /></IconButton>
                                                        :
                                                        <IconButton color="primary" onClick={() => this.addSMSOtp()}><AddCircle /></IconButton>
                                                }
                                            </div>
                                            : null
                                    }
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 10, paddingRight: 10, justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ textAlign: 'left', fontWeight: 'bold', paddingTop: 10, paddingBottom: 10 }}>Email Authentication:</div> {/* TODO: Implement Email OTP */}
                                    {
                                        this.state.user.otp_email_enabled ?
                                            <div style={{ textAlign: 'right', color: 'var(--green)', flex: 1 }}>{this.state.user.email.emailaddress}</div>
                                            :
                                            <div style={{ textAlign: 'right', color: 'var(--red)', flex: 1 }}>Disabled</div>
                                    }
                                    {
                                        this.isOwnProfile ?
                                            <div style={{ paddingLeft: 10 }}>
                                                {
                                                    this.state.user.otp_email_enabled ?
                                                        <IconButton color="secondary" onClick={() => this.removeEmailOtp()}><Clear /></IconButton>
                                                        :
                                                        <IconButton color="primary" onClick={() => this.addEmailOtp()}><AddCircle /></IconButton>
                                                }
                                            </div>
                                            : null
                                    }
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 10, paddingRight: 10, justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ textAlign: 'left', fontWeight: 'bold', paddingTop: 10, paddingBottom: 10 }}>2FA Authentication:</div>
                                    {
                                        this.state.user.otp_mfa_enabled && this.state.user.mfa_key ?
                                            <div style={{ textAlign: 'right', color: 'var(--green)', flex: 1 }}>Enabled</div>
                                            :
                                            (
                                                this.state.user.otp_mfa_enabled || this.state.user.mfa_key ?
                                                    <div style={{ textAlign: 'right', color: 'var(--red)', flex: 1 }}>Not Activated</div>
                                                    :
                                                    <div style={{ textAlign: 'right', color: 'var(--red)', flex: 1 }}>Disabled</div>
                                            )
                                    }
                                    {
                                        this.isOwnProfile ?
                                            <div style={{ paddingLeft: 10 }}>
                                                {
                                                    this.state.user.otp_mfa_enabled && this.state.user.mfa_key ?
                                                        <IconButton color="secondary" onClick={() => this.removeMFAOtp()}><Clear /></IconButton>
                                                        :
                                                        <IconButton color="primary" onClick={() => this.addMFAOtp()}><AddCircle /></IconButton>
                                                }
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
                {
                    this.state.user.hasSalesAccounts ?
                        <GridItem xs={12} sm={12} md={8}>
                            <Card>
                                <CardHeader color="warning" text>
                                    <CardText color="warning">
                                        <h4 className={classes.cardTitleWhite}>Top Accounts</h4>
                                        <h4 className={classes.cardCategoryWhite}>
                                            Gross Profit per Account
                                        </h4>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <StatsWrapper
                                        snackbar={this.snackbar}
                                        name="accountManagerGP"
                                        params={{ sales_id: this.state.user.id }}
                                        post
                                    >
                                        <AccountManagerGPChart />
                                        <AccountManagerGPTable />
                                    </StatsWrapper>
                                </CardBody>
                            </Card>
                            <Snackbar
                                key="snackbar"
                                place={this.state.snackbarPlace}
                                color={this.state.snackbarColor}
                                message={this.state.snackbarMessage}
                                open={this.state.snackbarOpen}
                                closeNotification={() => this.setState({ snackbarOpen: false })}
                                close
                            />
                        </GridItem>
                        : null
                }

                <SmallModal
                    id="areYouSure"
                    isOpen={this.state.dialog}
                    accept={() => this.setState({ dialog: false }, () => this.areYouSureFunction())}
                    close={() => this.setState({ dialog: false })}
                >
                    {this.state.dialogText}
                </SmallModal>

                <MFADialog
                    isOpen={this.state.mfaDialog}
                    close={() => this.setState({ mfaDialog: false })}
                    refresh={() => this.refreshCurrentUser()}
                />

                <SMSDialog
                    //isOpen={this.state.smsDialog}
                    isOpen={false}
                    close={() => this.setState({ smsDialog: false })}
                    refresh={() => this.refreshCurrentUser()}
                    contactNumber={this.state.user.contact_number}
                />

                <NotificationModal
                    open={this.state.smsDialog}
                    close={() => this.setState({ smsDialog: false })}
                >
                    <h3>Not Implemented Yet</h3>
                    <p>Apologies, but the SMS functionality has not yet been implemented on the backend.</p>
                </NotificationModal>

                <EmailDialog
                    isOpen={this.state.emailDialog}
                    close={() => this.setState({ emailDialog: false })}
                    refresh={() => this.refreshCurrentUser()}
                    email={this.state.user.email.emailaddress}
                />

            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        allUsers: state.allUsers.list
    };
}

export default withStyles({ ...userProfileStyles, ...styles })(connect(mapStateToProps)(ViewProfile));